import { render, staticRenderFns } from "./my-approval-list.vue?vue&type=template&id=11203ca8&scoped=true"
import script from "./my-approval-list.vue?vue&type=script&lang=js"
export * from "./my-approval-list.vue?vue&type=script&lang=js"
import style0 from "./my-approval-list.vue?vue&type=style&index=0&id=11203ca8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11203ca8",
  null
  
)

export default component.exports